const SORTING_TYPES = {
    number: ['Connected', 'Converted', 'Cost', 'Dupe', 'Incoming', 'Live', 'No Connect', 'Paid', 'Payout', 'Profit', 'Qualified', 'Revenue'],
    time: ['TCL', 'ACL'],
}

export { SORTING_TYPES }
